import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
  Text,
} from "@fluentui/react-components";
import { ICopyDiagnosticDialogProps } from "./copyDiagnosticDialog.types";

export const CopyDiagnosticDialog = (
  props: ICopyDiagnosticDialogProps,
): JSX.Element => {
  return (
    <Dialog open={props.open} modalType="alert">
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Copy Diagnostic</DialogTitle>
          <DialogContent>
            <Text size={300}>
              Creating a copy of the diagnostic "{props.diagnosticName}". You
              can find the copied diagnostic in your diagnostics list once the
              process is complete.
            </Text>
            <Spinner size="small" style={{ marginTop: "12px" }} />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
